let keyboardNavigation = false;

function clearKeyboardFocus() {
  document.querySelectorAll("[data-offers-filter][data-keyboard-focus]").forEach((filter) => {
    delete filter.dataset.keyboardFocus;
  });
}

document.addEventListener("keydown", (event) => {
  if (event.key === "Tab") keyboardNavigation = true;
});

document.addEventListener("pointerdown", () => {
  keyboardNavigation = false;
  clearKeyboardFocus();
});

document.addEventListener("focusin", (event) => {
  if (!event.target.matches("[data-offers-filter]")) return;
  if (keyboardNavigation) event.target.dataset.keyboardFocus = "true";
});

document.addEventListener("focusout", (event) => {
  if (!event.target.matches("[data-offers-filter]")) return;

  delete event.target.dataset.keyboardFocus;
});

document.addEventListener("change", (event) => {
  if (!event.target.matches("[data-offers-filter]")) return;

  const form = event.target.closest("[data-offers-filter-form]");
  if (form) form.requestSubmit();
});
